import React from 'react';
import { SelectFormField, type SelectFormFieldProps } from '~/shared/forms/controls/fields/SelectFormField';
import { getPatientContactsOptions, type PatientContactViewModel } from '@generated';
import { useQuery } from '@tanstack/react-query';

export function PatientContactSelectField({
	stayId,
	noContactsLabel = 'No contacts found',
	...props
}: Omit<SelectFormFieldProps, 'options'> & {
	stayId: string;
	noContactsLabel?: string;
	filterContact?: (contact: PatientContactViewModel) => boolean;
}) {
	const { data: patientContacts, isLoading } = useQuery(getPatientContactsOptions(stayId));

	if (isLoading || !patientContacts) {
		return null;
	}

	const options =
		patientContacts?.contacts.filter(contact => !props.filterContact || props.filterContact(contact)).map(x => ({ id: x.id, name: x.name })) ??
		[];
	return <SelectFormField options={options} {...props} placeholder="Select contact" noOptionsMessage={noContactsLabel} />;
}
